import { BaseDialogManager } from '../core/base-dialog-manager';
import { ManagerRegistry } from '../core/manager-registry';
import { t } from '../services/locale';
import type { EngineInfo } from '../components/engine';

export class EngineInfoDialogManager extends BaseDialogManager {
    protected get dialogId() { return 'engine-info-dialog'; }
    protected get dialogTitle() { return 'info.dialogTitle'; }
    protected get dialogWidth() { return 280; }


    constructor(registry: ManagerRegistry) {
        super(registry);
    }

    public init(): void {}

    protected getDialogPosition() {
        const container = this.registry.container;
        if (!container) return { x: 100, y: 100 };

        const containerWidth = container.clientWidth;
        const containerHeight = container.clientHeight;

        return {
            x: (containerWidth - this.dialogWidth) / 2,
            y: (containerHeight - 150) / 2
        };
    }

    protected createContent(): HTMLElement {
        const info: EngineInfo | null = this.engineComponent?.getEngineInfo() ?? null;

        const content = document.createElement('div');
        content.className = 'engine-info-content';
        content.style.cssText = 'padding: 16px;';

        const createRow = (label: string, value: number | string) => {
            const row = document.createElement('div');
            row.style.cssText = 'display: flex; justify-content: space-between; margin-bottom: 12px; font-size: 14px;';
            
            const labelEl = document.createElement('span');
            labelEl.style.cssText = 'color: var(--bim-text-secondary, #94a3b8);';
            labelEl.textContent = label;
            
            const valueEl = document.createElement('span');
            valueEl.style.cssText = 'color: var(--bim-text-primary, #fff); font-weight: 500;';
            valueEl.textContent = String(value);
            
            row.appendChild(labelEl);
            row.appendChild(valueEl);
            return row;
        };

        content.appendChild(createRow(t('info.meshCount'), info?.meshCount ?? '-'));
        content.appendChild(createRow(t('info.totalTriangles'), info?.totalTriangles ?? '-'));
        content.appendChild(createRow(t('info.totalVertices'), info?.totalVertices ?? '-'));

        return content;
    }
}
